module.exports = __webpack_public_path__ + "media/images/blobs/blob-pink-360c039d1aab777bb94500ad03c1e4ad.svg";